import IconButton from '@material-ui/core/IconButton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Paper from "@material-ui/core/Paper";
import { HeaderModalStyle } from "./styles";
const HeaderModal = ({children, handleClose, titulo}) =>{
    const classes = HeaderModalStyle();
    return (
        <div>
        <Paper elevation={0} className={classes.headerModal}>
           <h3 id="transition-modal-title">
            {titulo}
            </h3>
            <IconButton aria-label="closeModal"  onClick={handleClose}>
                <HighlightOffIcon/>
            </IconButton>
        </Paper>
        {
            children
        }
        </div>

    )
}
export default HeaderModal;